import React from 'react';

/**
 * Displays a market's image.
 * If `market.image2` is defined, shows both images side-by-side (used for "Mines et Énergie").
 * Otherwise shows a single image.
 * The className is applied to each <img> so the parent sets width/height/rounding.
 */
const MarketImage = ({ market, className = '', imgClassName = '' }) => {
  const baseImg = `w-full h-full object-cover ${imgClassName}`;

  if (market.image2) {
    return (
      <div className={`grid grid-cols-2 gap-0.5 w-full h-full ${className}`}>
        <img src={market.image} alt={market.title} className={baseImg} />
        <img src={market.image2} alt={`${market.title} 2`} className={baseImg} />
      </div>
    );
  }

  return (
    <img
      src={market.image}
      alt={market.title}
      className={`w-full h-full object-cover ${className} ${imgClassName}`.trim()}
    />
  );
};

export default MarketImage;
